import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClassiFabbricatoFormComponent } from './dialogs/form/form.component';
import { ClassiFabbricatoComponent } from './classi-fabbricato.component';


const routes: Routes = [
  {
    path: '', component: ClassiFabbricatoComponent
  },
  {
    path: 'inserisci', component: ClassiFabbricatoFormComponent,
    data: { title: 'Inserimento ClassiFabbricato' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClassiFabbricatoRoutingModule { }
